"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_7.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var merc = {
  id: "merc",
  title: {
    en: "Lesson 7 (Merc)",
    de: "Lektion 7 (Söldner)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Using Mercenary"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "When any class reaches level 5, one can acquire a helper to help you in your hunt."), /*#__PURE__*/_react.default.createElement("li", null, "If you want to acquire a Mercenary, go to the mercenary office. You must be at least level 5 and you have to be a party leader or not in a party. You cannot have an existing mercenary, summoners cannot acquire a mecenary if they have already summoned a creature."), /*#__PURE__*/_react.default.createElement("li", null, "A Mercenary is an NPC that can be acquired for a limited time through a contract. You must reacquire them before time expires."), /*#__PURE__*/_react.default.createElement("li", null, "There are different types of Mercenaries you can acquire. There are knights, archers, and clerics, they will be equal to your level. Generally a warrior class is best to aquire for a cleric, so if you are a wizard or a cleric it would be best to acquire a knight to help you in your defense."), /*#__PURE__*/_react.default.createElement("li", null, "If you would like to know more about Mercenaries, go to the mercenary tab to obtain more information.")))
  }
};
var _default = merc;
exports.default = _default;